import {
  Component
} from '@angular/core';

@Component({
  selector: 'app-tether-dialog__overlay',
  template: '',
  host: {'class': 'c-tether-dialog__overlay'}
})
export class TetherDialogOverlayComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/common-module/modules/tether-dialog/tether-dialog-overlay.component.ts